export function call(ctrl, name, args = []) {
  if (!ctrl) return;

  const method = ctrl[name];
  if (typeof method == "function") {
    // Ensure single arguments are enclosed in array
    return method.call(ctrl, ...[].concat(args));
  }
}

export function getControllerName(ctrl) {
  return ctrl.context.module.definition.identifier;
}
